import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { Link } from "react-router-dom";
import "react-form-wizard-component/dist/style.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getEmployeeList } from "../../EmployeeList/Service/employeeService";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { Dropdown } from "primereact/dropdown";
import { TostMsg } from "../../../../App";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from "react-redux";
import { setLeaveRequestData } from "../../../../Services/Redux/DataTransferToAnother";
import { PostWFHAdjustment } from "../Wfh/WfhSerevice";
import WfhNavBarItems from "../Wfh/WfhCommon/WfhNavBarItems";
const ComponentLoader = React.lazy(() =>
  import("../../../../Shared/Sidebar/ComponentLoader")
);
function WFHAdjustment() {

  const dispatch = useDispatch();
  const [AddMore, setAddMore] = React.useState(0);
  const [Isloading, setIsloading] = useState(false);
  const [employeDetails, setEmployeeDetails] = useState([]);
  const [wfhStatus, setWfhStatus] = useState([
    { Id: 1, WFHStatus: "Credit " },
    { Id: 2, WFHStatus: "Debit " },
  ]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const toster = useContext(TostMsg);
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const history = useHistory();
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [howItWorkHeader, setHowItWorkHeader] = useState([]);
  const [howItWorkText, setHowItWorkText] = useState([]);
  const [wfhSubheadingText, setWFHSubheadingText] = useState([]);

  useEffect(() => {
    GetMasterSystemAlertList();
    // fetchEmployeeIdData();
  }, []);

  var BasicInfo = false;
  let EmplyeeInfo = false;
  let PersonalInfo = false;

  const renderComponent = () => {
    if (AddMore == 0) {
      BasicInfo = true;
      EmplyeeInfo = false;
      PersonalInfo = false;
    } else if (AddMore == 1) {
      BasicInfo = false;
      EmplyeeInfo = true;
      PersonalInfo = false;
    } else {
      BasicInfo = false;
      EmplyeeInfo = false;
      PersonalInfo = true;
    }
  };

  //For get the employee data.
  async function fetchEmployeeIdData() {
    setIsloading(true);
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 3,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 100000,
      EmployeeId: userDetails?.EmpId,
      IsSuggestedOnly: 0,
    };

    try {
      let employeesList = await getEmployeeList(params);
      let employeeValidateList = [];
      // let employeesList = await data.json();
      employeeValidateList = employeesList.Data?.filter(
        (el) => el?.EmpId != userDetails?.EmpId
      );
      setEmployeeDetails(employeeValidateList);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }
  const requestWfhValidation = Yup.object().shape({
    EmpId: Yup.string().required("Employee is required."),
    WFHCount: Yup.string().required("WFH count is required."),
    comment: Yup.string().required("Comment is required."),
    CreditOrDebit: Yup.string().required("WFH status is required."),
  });

  const requestWFHForm = useFormik({
    initialValues: {
      EmpId: "",
      WFHCount: "",
      comment: "",
      CreditOrDebit: "",
    },
    validationSchema: requestWfhValidation,
    onSubmit: async (data) => {
      setIsloading(true);
      let CreditDebit;
      if (data?.CreditOrDebit == 1) {
        CreditDebit = "CR";
      } else {
        CreditDebit = "DR";
      }

      const wfhRequestParams = {
        LoggedInEmpId: userDetails?.EmpId,
        OrgId: userDetails?.OrgId,
        WFHCount: data?.WFHCount,
        EmpId: Number(data?.EmpId),
        Comment: data?.comment,
        CreditOrDebit: CreditDebit,
      };
      try {
        if (isWfhCount == false) {
          const applyWFHResponse = await PostWFHAdjustment(wfhRequestParams);
          if (applyWFHResponse?.StatusCode === 2000) {
            setIsloading(false);
            GetMasterSystemAlertList("Leave_Adjust", 0);
            requestWFHForm.resetForm();
            dispatch(setLeaveRequestData(wfhRequestParams));
            history.push("/ledger");
          } else {
            const message = applyWFHResponse?.Message;
            toster.current.warn(message);
            setIsloading(false);
          }
          setisWFHCount(false);
        } else {
          setisWFHCount(true);
        }
      } catch (error) {
        setIsloading(false);
        toster.current.error("Something went wrong.");
      } finally {
        setIsloading(false);
      }
    },
  });

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setMasterSystemAlertData(msg?.Desc);
      }

      if (msg?.Name == "OrGenie_HowItWorks_Header") {
        setHowItWorkHeader(msg?.Desc);
      }
      if (msg?.Name == "WFH_Adjustment_Text") {
        setHowItWorkText(msg?.Desc);
      }

      if (msg?.Name == "Adjust_WFH") {
        setWFHSubheadingText(msg?.Desc);
      }
    });
  }, []);

  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage
          alt={option?.FullName}
          src={option?.ProfileImage}
          width="32"
        />
        <span>
          {option?.FullName}
          {option?.CurrentDesignation?.length > 0 && ","}
        </span>
        {/* <span>
          {option?.UserName}
          {option?.CurrentDesignation?.length > 0 && ","}
        </span> */}
        <span>{option?.CurrentDesignation}</span>
      </div>
    );
  };

  const [isWfhCount, setisWFHCount] = useState(false);
  useEffect(() => {
    let WFHDecimalValue = requestWFHForm.values.WFHCount?.toString();
    let FinalValue = WFHDecimalValue?.slice(-2);
    if (WFHDecimalValue?.length == 3) {
      if (FinalValue == ".5") {
        setisWFHCount(false);
      } else {
        setisWFHCount(true);
      }
    } else if (WFHDecimalValue?.length == 4) {
      if (FinalValue == ".5") {
        setisWFHCount(false);
      } else {
        setisWFHCount(true);
      }
    } else {
      setisWFHCount(false);
    }
  }, [requestWFHForm.values.WFHCount]);

  return (
    <div>
      {renderComponent()}
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid position-relation">
        <div className="row">
          <div className="">
            <div className="form-head d-flex flex-wrap align-items-center mb-3">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">
                  <img src="images/new-emp.png" />
                  WFH Adjustment
                </h2>
                <p className="text-light">{wfhSubheadingText}</p>
              </div>
              <div className="rightside-tabs">
                <WfhNavBarItems />
              </div>
              {AddMore != 0 && (
                <div
                  className="rightside-tabs"
                  onClick={() => setAddMore(AddMore - 1) % 3}
                >
                  {/* <Link to="Dashboard"> */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    className="bi bi-arrow-left-short"
                    viewBox="0 0
 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 8a.5.5 0 0 1-.5.5H5.7
 07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
 .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                    ></path>
                  </svg>
                  {/* </Link> */}
                </div>
              )}
            </div>
            {BasicInfo && (
              <div className="formfill-addemployee">
                <div className="row justify-content-center">
                  <div className="col-xl-8">
                    <div className="supp-req">
                      <div className="addcourseform">
                        <form onSubmit={requestWFHForm.handleSubmit}>
                          <span className="tagtitle">WFH Details </span>
                          <div className="row mt-3">
                            <div className="mb-4 col-md-12">
                              <div className="innerform-grp">
                                <label className="form-label">
                                  Team Member
                                </label>
                                <Dropdown
                                  value={requestWFHForm.values.EmpId}
                                  onClick={() => fetchEmployeeIdData()}
                                  onChange={requestWFHForm.handleChange}
                                  options={employeDetails}
                                  filter={true}
                                  optionLabel="FullName"
                                  optionValue="EmpId"
                                  placeholder="Choose"
                                  maxSelectedLabels={1}
                                  itemTemplate={employeeOptionTemplate}
                                  name="EmpId"
                                  className={
                                    "w-100 md:w-20rem p-0 h-40 line-height-40 custom-multiselect" +
                                    (requestWFHForm.errors.EmpId &&
                                      requestWFHForm.touched.EmpId
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </div>
                              <div className="invalid-feedback">
                                {requestWFHForm.errors.EmpId &&
                                  requestWFHForm.touched.EmpId
                                  ? requestWFHForm.errors.EmpId
                                  : null}
                              </div>
                            </div>
                            {requestWFHForm.values.EmpId && (
                              <div className="mb-4 col-md-6">
                                <div className="innerform-grp">
                                  <label className="form-label">
                                    WFH Status
                                  </label>
                                  <div className="cover-form">
                                    <Dropdown
                                      onChange={requestWFHForm.handleChange}
                                      name="CreditOrDebit"
                                      value={
                                        requestWFHForm.values.CreditOrDebit
                                      }
                                      options={wfhStatus}
                                      optionLabel="WFHStatus"
                                      optionValue="Id"
                                      placeholder="Choose"
                                      checkmark={true}
                                      highlightOnSelect={false}
                                      className={
                                        "w-100 md:w-20rem p-0 h-40 line-height-40 custom-multiselect"
                                      }
                                    />
                                  </div>
                                  <div className="invalid-feedback">
                                    {requestWFHForm.errors.CreditOrDebit &&
                                      requestWFHForm.touched.CreditOrDebit
                                      ? requestWFHForm.errors.CreditOrDebit
                                      : null}
                                  </div>
                                </div>
                              </div>
                            )}

                            {requestWFHForm.values.CreditOrDebit && (
                              <div className="mb-4 col-md-6">
                                <div className="innerform-grp">
                                  <label className="form-label">
                                    WFH Count
                                  </label>
                                  <div className="cover-form d-block w-100">
                                    <input
                                      type="number"
                                      min="0"
                                      max="50"
                                      oninput="validity.valid||(value='');"
                                      step="0.5"
                                      // max="18" step="0.5" pattern="\d+"
                                      name="WFHCount"
                                      onWheel={(e) => e.target.blur()}
                                      className={
                                        "form-control" +
                                        (requestWFHForm.errors.WFHCount &&
                                          requestWFHForm.touched.WFHCount
                                          ? " is-invalid"
                                          : "")
                                      }
                                      onChange={requestWFHForm.handleChange}
                                      value={requestWFHForm.values.WFHCount}
                                      placeholder="WFH Count"
                                    />
                                  </div>
                                  {isWfhCount && (
                                    <div className="invalid-feedback">
                                      <p>* Only allowed decimal value 0.5</p>{" "}
                                    </div>
                                  )}
                                  <div className="invalid-feedback">
                                    {requestWFHForm.errors.WFHCount &&
                                      requestWFHForm.touched.WFHCount
                                      ? requestWFHForm.errors.WFHCount
                                      : null}
                                  </div>
                                </div>
                              </div>
                            )}
                            {requestWFHForm.values.WFHCount?.toString()
                              ?.length > 0 && (
                                <div className="mb-4 col-md-12">
                                  <div className="innerform-grp">
                                    <label className="form-label">Comment</label>
                                    <div className="cover-form">
                                      <input
                                        type="text"
                                        name="comment"
                                        className={
                                          "form-control" +
                                          (requestWFHForm.errors.comment &&
                                            requestWFHForm.touched.comment
                                            ? " is-invalid"
                                            : "")
                                        }
                                        onChange={requestWFHForm.handleChange}
                                        value={requestWFHForm.values.comment}
                                      />
                                    </div>
                                    <div className="invalid-feedback">
                                      {requestWFHForm.errors.comment &&
                                        requestWFHForm.touched.comment
                                        ? requestWFHForm.errors.comment
                                        : null}
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="btns-grp text-right">
                                <button
                                  type="submit"
                                  className="savebtn-click m-0"
                                >
                                  Submit Request
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4">
                    <div className="side-add-section pl-0">
                      <div className="card right-div">
                        <div className="card-body">
                          <div className="text-center">
                            <h4 className="how-it mb-4">{howItWorkHeader}</h4>
                            <img
                              src="images/org-img/leave/leave_adjustment.svg"
                              style={{ width: "70%" }}
                            />
                            <ul className="ul-work text-dark text-left mt-4">
                              <li>
                                <i className="fa fa-check-square-o"></i>
                                {howItWorkText}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}
export default WFHAdjustment;
